export const Link = "https://sekyererbapis.cbxapps.com";
// export const Link = "http://localhost:5001";
